import { render } from "./CustomAutocompleteUser.vue?vue&type=template&id=0f2563c2"
import script from "./CustomAutocompleteUser.vue?vue&type=script&lang=js"
export * from "./CustomAutocompleteUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__